import React from "react";
import BackgroundImage from "../assets/images/contact/bg-09.jpg";
import EmailIcon from "../assets/images/icons/icon-email.png";
// import PlanoMap from "../assets/images/contact/plano_map.png";
import Layout from "../components/layout";
import videoSource from '../assets/videos/cutting_leather.mp4';
import NewsletterForm from "../components/newsletterform";

const Contact = () => {
    return (
        <div>
            <Layout>
            {/* Title Section */}
            <section
                className="bg-img1 txt-center p-lr-15 p-tb-92"
                style={{ backgroundImage: `url(${BackgroundImage})` }}
            >
                <h2 className="ltext-105 cl0 txt-center">Contact</h2>
            </section>              

                {/* Content Section */}
                <section className="bg0 p-t-60 p-b-125">
                    <div className="container">
                        <div className="flex-w flex-tr">
                            {/* Contact Form */}
                            <div className="size-210 bor10 p-lr-70 p-t-55 p-b-70 p-lr-15-lg w-full-md">
                                <NewsletterForm></NewsletterForm>
                            </div>

                            {/* Contact Details */}
                            <div className="size-210 bor10 flex-w flex-col-m p-lr-93 p-tb-30 p-lr-15-lg w-full-md">
                                <div className="flex-w w-full p-b-42">
                                    <span className="fs-18 cl5 txt-center size-211">
                                        <span className="lnr lnr-map-marker"></span>
                                    </span>
                                    <div className="size-212 p-t-2">
                                        <span className="mtext-110 cl2">Address</span>
                                        <p className="stext-115 cl6 size-213 p-t-18">
                                            5473 Blair Rd Ste 100 PMB 895415 US Dallas, Texas 75231-4227 US
                                        </p>
                                    </div>
                                </div>
                                <div className="flex-w w-full p-b-42">
                                    <span className="fs-18 cl5 txt-center size-211">
                                        <span className="lnr lnr-phone-handset"></span>
                                    </span>
                                    <div className="size-212 p-t-2">
                                        <span className="mtext-110 cl2">Lets Talk</span>
                                        <p className="stext-115 cl1 size-213 p-t-18">+1 469 5569634</p>
                                    </div>
                                </div>
                                <div className="flex-w w-full">
                                    <span className="fs-18 cl5 txt-center size-211">
                                        <span className="lnr lnr-envelope"></span>
                                    </span>
                                    <div className="size-212 p-t-2">
                                        <span className="mtext-110 cl2">Sales Support</span>
                                        <p className="stext-115 cl1 size-213 p-t-18">support@molubags.com</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Map Section
                <section className="map">
                        <img
                            src={PlanoMap}
                            alt="Plano Map"
                            style={{ width: "100%", height: "auto", display: "block" }}
                        />
                </section> */}
            </Layout>
        </div>
    );
};

export default Contact;
